import { StatusBadge } from "@/components/ui/status-badge";
import type { BinderyItemStatus, BinderyRequestStatus, ThesisPrintStatus } from "@/lib/api/bindery";

type Variant = React.ComponentProps<typeof StatusBadge>["variant"];

const REQUEST_MAP: Record<BinderyRequestStatus, { variant: Variant; label: string }> = {
  DRAFT: { variant: "neutral", label: "Draft" },
  SENT: { variant: "info", label: "Sent to bindery" },
  IN_REPAIR: { variant: "purple", label: "In repair" },
  RETURNED: { variant: "warning", label: "Returned — QC" },
  CLOSED: { variant: "success", label: "Closed" },
  CANCELLED: { variant: "danger", label: "Cancelled" },
};

const ITEM_MAP: Record<BinderyItemStatus, { variant: Variant; label: string }> = {
  FLAGGED: { variant: "neutral", label: "Flagged" },
  AT_BINDERY: { variant: "info", label: "At bindery" },
  QC_PENDING: { variant: "warning", label: "QC pending" },
  READY_TO_SHELVE: { variant: "success", label: "Ready to shelve" },
  RETURNED_UNREPAIRED: { variant: "danger", label: "Unrepaired" },
  COMPLETED: { variant: "success", label: "Completed" },
  CANCELLED: { variant: "danger", label: "Cancelled" },
};

const THESIS_MAP: Record<ThesisPrintStatus, { variant: Variant; label: string }> = {
  SUBMITTED: { variant: "neutral", label: "Submitted" },
  FORMAT_CHECK: { variant: "info", label: "Format check" },
  APPROVED: { variant: "info", label: "Approved" },
  PRINTING: { variant: "purple", label: "Printing" },
  BINDING: { variant: "purple", label: "Binding" },
  READY: { variant: "success", label: "Ready for pickup" },
  COLLECTED: { variant: "success", label: "Collected" },
  REJECTED: { variant: "danger", label: "Rejected" },
  CANCELLED: { variant: "danger", label: "Cancelled" },
};

export function BinderyRequestStatusBadge({ status }: { status: BinderyRequestStatus }) {
  const cfg = REQUEST_MAP[status];
  return <StatusBadge variant={cfg.variant}>{cfg.label}</StatusBadge>;
}

export function BinderyItemStatusBadge({ status }: { status: BinderyItemStatus }) {
  const cfg = ITEM_MAP[status];
  return <StatusBadge variant={cfg.variant}>{cfg.label}</StatusBadge>;
}

export function ThesisStatusBadge({ status }: { status: ThesisPrintStatus }) {
  const cfg = THESIS_MAP[status];
  return <StatusBadge variant={cfg.variant}>{cfg.label}</StatusBadge>;
}
